import { useEffect } from 'react';
import { pageTitle } from '../lib/title';

/** Names the browser tab after the open page while it is shown (OIL-264). */
export function useDocumentTitle(...parts: readonly (string | null | undefined)[]): void {
  const title = pageTitle(...parts);
  useEffect(() => {
    const before = document.title;
    document.title = title;
    return () => {
      document.title = before;
    };
  }, [title]);
}
